<div
    class="mp-total-revenue-card trezo-card mb-25 border-radius d-block bg-white border-0 shadow-none"
    [class.component-dark-theme]="themeService.isDark()"
>
    <div class="trezo-card-content">
        <span class="d-block">
            Total Revenue
        </span>
        <h5 class="mb-0">
            $34.5m+
        </h5>
        <div class="icon mx-auto text-orange bg-orange-100 rounded-circle mx-auto d-flex align-items-center justify-content-center">
            <i class="material-symbols-outlined">
                payments
            </i>
        </div>
        <div class="info d-flex align-items-center justify-content-between">
            <span class="d-block">
                This Month
            </span>
            <span class="lh-1 text-success">
                <i class="material-symbols-outlined">
                    trending_up
                </i>
            </span>
        </div>
    </div>
</div>